module.exports = __webpack_public_path__ + "static/img/complianceSystem3.59a95cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Home/complianceSystem3.jpg
// module id = /z+B
// module chunks = 1